<template>
  <div class="container">
    <PublicHeader totalName="微信/支付宝" />
    <div class="tabs">
      <div :class="{ active: type === 'WeChat' }" @click="changeType('WeChat')">微信</div>
      <div :class="{ active: type === 'Alipay' }" @click="changeType('Alipay')">支付宝</div>
    </div>
    <div class="box">
      <van-field
        v-if="type === 'Alipay'"
        v-model.trim="receiverName"
        label="收款人姓名"
        placeholder="请输入支付宝收款人姓名"
      />
      <div class="qr-title">{{ type === 'WeChat' ? '微信' : '支付宝' }}收款码</div>
      <van-uploader v-if="!isBound" :after-read="afterRead" :max-count="1" :preview-image="false">
        <div class="qr-upload">
          <div v-if="qrCode" class="qr-status">
            <van-icon name="passed" size="32" />
            <p>收款码已上传</p>
          </div>
          <div v-else>
            <van-icon name="photograph" size="32" />
            <p>上传收款码</p>
          </div>
        </div>
      </van-uploader>
      <div v-else class="qr-upload bound-qr">
        <div class="qr-status">
          <van-icon name="passed" size="32" />
          <p>收款码已绑定</p>
        </div>
      </div>
      <p class="notice" v-if="isBound">收款码已绑定，如需修改请联系客服。</p>
      <p class="notice" v-else>请上传清晰、有效的收款二维码，提现审核将按此二维码付款。绑定成功后只能由后台修改。</p>
    </div>
    <div v-if="!isBound" class="bigBtn" @click="save">确认绑定</div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import userApi from '@/api/user'
import { mapGetters } from 'vuex'

export default {
  components: { PublicHeader },
  data() {
    return {
      type: this.$route.query.type === 'Alipay' ? 'Alipay' : 'WeChat',
      receiverName: '',
      qrCode: '',
      isBound: false,
      userInfo: {},
    }
  },
  computed: {
    ...mapGetters(['basicConfig']),
  },
  methods: {
    fill() {
      const prefix = this.type === 'WeChat' ? 'WeChat' : 'Alipay'
      this.receiverName = this.userInfo[prefix + 'ReceiverName'] || ''
      this.qrCode = this.userInfo[prefix + 'QrCode'] || ''
      this.isBound = Boolean(this.qrCode)
    },
    changeType(type) {
      this.type = type
      this.fill()
    },
    async afterRead(file) {
      const formdata = new FormData()
      formdata.append('userfile[0]', file.file)
      this.qrCode = await userApi.upCaptchaFile(formdata)
    },
    async save() {
      if (this.type === 'Alipay' && !this.receiverName) return this.$toast('请输入支付宝收款人姓名')
      if (!this.qrCode) return this.$toast('请上传收款码')
      await userApi.updatePaymentAccount({
        Type: this.type,
        ReceiverName: this.receiverName,
        QrCode: this.qrCode,
      })
      this.$toast.success('保存成功')
      this.userInfo = await userApi.userInfo()
      this.fill()
    },
  },
  async mounted() {
    if (!this.basicConfig.IsWeChatAlipayWithdrawal) {
      this.$toast('微信/支付宝提现方式未开启')
      this.$router.go(-1)
      return
    }
    this.userInfo = await userApi.userInfo()
    this.fill()
  },
}
</script>

<style lang="stylus" scoped>
@import "~@/styles/mixin.styl";
.container
  width 100%
  min-height 100vh
  padding-top 48.5px
  background #1f1f1f
  color #ebe5cd
  font-size 14px
  line-height 1.5
  overflow-x hidden
  .tabs
    display flex
    margin 18px 14px 0
    border 1Px solid #d6b372
    border-radius 5px
    overflow hidden
    div
      flex 1
      height 42px
      flex-center()
      font-size 15px
      line-height 42px
    .active
      color #222
      background linear-gradient(315deg,#e8d49e,#d6b372)
  .box
    margin 15px 14px
    padding-bottom 18px
    border 1Px solid #40404b
    border-radius 5px
    >>> .van-cell
      color #ebe5cd
      background transparent
      border-bottom 1Px solid #40404b
      font-size 14px
      line-height 24px
    >>> .van-field__control
      color #fff
    .qr-title
      padding 18px 12px 12px
      font-size 15px
      line-height 22px
      text-align center
    >>> .van-uploader
      display block
      width 204px
      margin 0 auto
    >>> .van-uploader__input-wrapper
      display block
    .qr-upload
      width 180px
      height 180px
      margin 0 auto
      flex-center()
      text-align center
      color #d6b372
      border 1Px dashed #777
      border-radius 5px
      overflow hidden
      font-size 14px
      line-height 20px
      img
        width 100%
        height 100%
        object-fit contain
      p
        margin 8px 0 0
        font-size 14px
        line-height 20px
    .bound-qr
      margin 0 auto
    .notice
      margin 12px
      color #999
      font-size 12px
      line-height 18px
      text-align center
  .bigBtn
    width 92%
    height 40px
    margin 36px auto
    flex-center()
    font-size 15px
    line-height 40px
    color #222
    border-radius 5px
    background linear-gradient(315deg,#e8d49e,#d6b372)
</style>
